<template>
  <a-drawer :title="title" width="60%" :visible="visible" :body-style="{ paddingBottom: '80px' }" @close="hide">
    <a-spin :spinning="loading">
      <div class="drawer-content">
        <a-descriptions title="基本信息" :column="2" bordered>
          <a-descriptions-item label="区域编码">
            {{ detailData.areaCode || '-' }}
          </a-descriptions-item>
          <a-descriptions-item label="区域名称">
            {{ detailData.areaName || '-' }}
          </a-descriptions-item>
          <a-descriptions-item label="区域层级">
            <a-tag :color="getAreaLevelColor(detailData.areaLevel)">
              {{ getAreaLevelText(detailData.areaLevel) }}
            </a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="父级区域ID">
            {{ detailData.parentId === 0 ? '省级（无父级）' : detailData.parentId || '-' }}
          </a-descriptions-item>
          <a-descriptions-item label="状态">
            <a-tag :color="detailData.status === 1 ? 'green' : 'red'">
              {{ detailData.status === 1 ? '启用' : '禁用' }}
            </a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="创建时间">
            {{ formatTime(detailData.createTime) || '-' }}
          </a-descriptions-item>
        </a-descriptions>

        <a-descriptions title="其它信息" :column="1" bordered style="margin-top: 16px">
          <a-descriptions-item label="备注">
            <a-tooltip v-if="detailData.remark" :title="detailData.remark">
              <span class="text-ellipsis">{{ detailData.remark || '无备注' }}</span>
            </a-tooltip>
            <span v-else>无备注</span>
          </a-descriptions-item>
        </a-descriptions>
      </div>
    </a-spin>

    <div class="drawer-footer">
      <a-button @click="hide">关闭</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { getAreaDetail } from '@/api/profitSharing/proportionalArea'
import { message } from 'ant-design-vue'

export default {
  name: 'DetailDrawer',
  data() {
    return {
      visible: false,
      loading: false,
      detailData: {},
    }
  },
  computed: {
    title() {
      return '维修区域详情'
    },
  },
  methods: {
    init(record) {
      this.visible = true
      if (record && record.id) {
        this.loadDetail(record.id)
      } else {
        this.detailData = {}
      }
    },
    hide() {
      this.visible = false
      this.detailData = {}
    },
    async loadDetail(id) {
      this.loading = true
      try {
        const response = await getAreaDetail(id)
        if (response && response.success && response.data) {
          this.detailData = response.data
        } else {
          message.error(response.message || '获取详情失败')
        }
      } catch (error) {
        console.error('获取详情失败:', error)
        message.error('获取详情失败')
      } finally {
        this.loading = false
      }
    },
    formatTime(time) {
      if (!time) return '-'
      return time
    },
    getAreaLevelText(areaLevel) {
      const map = {
        1: '省',
        2: '市',
        3: '区',
      }
      return map[areaLevel] || '-'
    },
    getAreaLevelColor(areaLevel) {
      const map = {
        1: 'blue',
        2: 'green',
        3: 'orange',
      }
      return map[areaLevel] || 'default'
    },
  },
}
</script>

<style scoped>
.drawer-content {
  padding: 0;
}

.drawer-footer {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}

.ant-descriptions {
  margin-bottom: 0;
}

.text-ellipsis {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

:deep(.ant-descriptions-title) {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

:deep(.ant-descriptions-item-label) {
  white-space: nowrap;
}
</style>
